import { BaseInsuranceStatus } from '@/classes/SubmissionStatuses/BaseInsuranceStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'

export class PendingStatus extends BaseInsuranceStatus {
	getToolTipText() {
		return {
			title: this.getStatusText(),
			body:
				'This packet is pending submission to ' +
				this.getVendorName() +
				' and will update once completed. Have questions? Contact salesstudio@precoa.com.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.PENDING
	}
}
